"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var reactive_vue_1 = require("@formily/reactive-vue");
var vue_1 = require("@formily/vue");
var vue_demi_1 = require("vue-demi");
// @ts-ignore
var serverDirectAllocationTable_vue_1 = __importDefault(require("./serverDirectAllocationTable.vue"));
var formilyServerDirectAllocationTable = (0, reactive_vue_1.observer)((0, vue_demi_1.defineComponent)({
    name: 'serverDirectAllocationTable',
    props: ['value', 'toggle'],
    setup: function (curProps, _a) {
        var attrs = _a.attrs, emit = _a.emit;
        return function () { return (0, vue_1.h)(serverDirectAllocationTable_vue_1.default, {
            attrs: __assign(__assign({}, curProps), attrs),
            on: {
                change: function (val) {
                    emit('change', val);
                },
                'selection-change': function (val) {
                    emit('selectionChange', val);
                },
            },
        }, {
            default: function () { return [curProps.value || attrs.content]; },
        }); };
    },
}));
exports.default = formilyServerDirectAllocationTable;
